import { z } from 'zod';

export type Camera = z.output<typeof cameraSchema>;
export type CameraDTO = z.input<typeof cameraSchema>;

export const cameraSchema = z.object({
  id: z.string(),
  name: z.string(),
  vendorId: z.string(),
});
